import { string, object, date, number, array } from "yup";

export const CommissionSchema = object({

    commission: number().required("commission obligatoire!!"),
    article_id: array(),
    date_debut: string().required('date_debut obligatoire'),
    date_fin:string().required('date_fin obligatoire')
});
 